import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedWeekStart,
  setSelectedWeekEnd,
} from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";

export default function WeekSelector({ weeks = [], disabled = false, formControlSx }) {
  const dispatch = useDispatch();
  const selectedWeekStart = useSelector(
    (state) => state.promoSimulator.selectedWeekStart
  );
  const selectedWeekEnd = useSelector(
    (state) => state.promoSimulator.selectedWeekEnd
  );

  const handleStartChange = (e) => {
    const v = e.target.value;
    const next = v === "" ? null : Number(v);
    dispatch(setSelectedWeekStart(next));
    if (next != null && selectedWeekEnd != null && selectedWeekEnd < next) {
      dispatch(setSelectedWeekEnd(next));
    }
  };

  const handleEndChange = (e) => {
    const v = e.target.value;
    dispatch(setSelectedWeekEnd(v === "" ? null : Number(v)));
  };

  const startValue = selectedWeekStart != null ? selectedWeekStart : "";
  const endValue = selectedWeekEnd != null ? selectedWeekEnd : "";
  const endOptions =
    selectedWeekStart != null
      ? weeks.filter((w) => Number(w.id) >= Number(selectedWeekStart))
      : weeks;
  const isDisabled = disabled || weeks.length === 0;

  return (
    <Box display="flex" gap={1}>
      <FormControl fullWidth size="small" disabled={isDisabled} sx={formControlSx}>
        <InputLabel>Start week</InputLabel>
        <Select value={startValue} label="Start week" onChange={handleStartChange}>
          {weeks.map((w) => (
            <MenuItem key={w.id} value={w.id}>
              {w.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth size="small" disabled={isDisabled} sx={formControlSx}>
        <InputLabel>End week</InputLabel>
        <Select value={endValue} label="End week" onChange={handleEndChange}>
          {endOptions.map((w) => (
            <MenuItem key={w.id} value={w.id}>
              {w.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
